module.exports = __webpack_public_path__ + "img/bbg.a5d453f0.png";